import { createContext, useContext } from 'react';

import type { MenuControlContext as ContextProps, HomeFormControlCallbacks } from './types';

const defaultFormControls: ContextProps = {
	load: function (): void {},
	reset: function (): void {},
	close: function (): void {},
	mixedItems: [],
	product: 'unknown',
	subProduct: undefined,
	suggestionConfig: {
		enabled: false,
	},
	isNav4Enabled: true,
};

export const MenuControlContext = createContext<ContextProps>(defaultFormControls);

export function useMenuControl() {
	return useContext(MenuControlContext);
}

export const HomeFormControlContext = createContext<HomeFormControlCallbacks>({
	goal: undefined,
	team: undefined,
	project: undefined,
});

export function useHomeFormControl() {
	return useContext(HomeFormControlContext);
}
